import React, { useState } from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { OrderDetailsFormWrapperValues } from "src/models/OrderDetailsFormWrapper.model";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import useAttempt from "src/hooks/useAttempt";
import ATMMultiSelect from "src/components/UI/atoms/formFields/ATMMultiSelect/ATMMultiSelect";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";
import { handleValidNumber2 } from "src/utils/formUtils/ValidNumber";

type Props = {
  formikProps: FormikProps<OrderDetailsFormWrapperValues>;
};
const DeliveryOptions = [
  {
    label: "PICKUP",
    value: "PICKUP",
  },
  {
    label: "HOME_DELIVERY",
    value: "HOME_DELIVERY",
  },
];

const OrderDetailsForm = ({ formikProps }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;
  const [isEditable, setIsEditable] = useState(false);

  //attempt options
  const { attempt, isDataLoading: isAttemptIsLoading } = useAttempt();

  const AttemptOptions = attempt?.map((attempt: any) => {
    return {
      label: attempt?.attempt,
      value: attempt?._id,
    };
  });

  return (
    <div className="p-4 flex flex-col gapbetween-6">
      <div className="flex justify-end gap-6">
        <ATMLoadingButton
          className={`w-24 font-medium ${
            isEditable ? "bg-primary-main  text-white" : "bg-white text-black"
          }`}
          onClick={() => {
            setIsEditable(true);
          }}
        >
          Edit
        </ATMLoadingButton>
        <ATMLoadingButton
          className={`w-28 font-medium ${
            !isEditable ? "bg-primary-main  text-white" : "bg-white text-black"
          }`}
          onClick={() => {
            setIsEditable(false);
          }}
        >
          Cancel
        </ATMLoadingButton>
      </div>
      <div className="flex justify- items-center">
        <div className="text-xl font-medium">Update Order Deatils</div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 my-6">
        {/* Name */}
        <ATMTextField
          disabled={!isEditable}
          required
          name="name"
          value={values.name}
          onChange={(e) => {
            setFieldValue("name", e.target.value);
          }}
          label="Name"
          placeholder="Enter Name"
          onBlur={handleBlur}
        />
        {/* Email */}
        <ATMTextField
          disabled={!isEditable}
          required
          name="email"
          value={values?.email}
          onChange={(e) => {
            setFieldValue("email", e.target.value);
          }}
          label="Email"
          placeholder="Enter email"
          onBlur={handleBlur}
        />
        {/* Mobile */}
        <ATMTextField
          disabled={!isEditable}
          required
          name="mobile"
          maxLength={10}
          value={values?.mobile}
          onChange={(e) => {
            handleValidNumber2(e) && setFieldValue("mobile", e.target.value);
          }}
          label="Mobile"
          placeholder="Enter Mobile"
          onBlur={handleBlur}
        />
        {/* user Type */}
        <ATMSelect
          disabled={!isEditable}
          name="userType"
          required
          placeholder="User Type"
          label="User Type"
          isLoading={isAttemptIsLoading}
          options={AttemptOptions}
          onChange={(newValue: any) => {
            setFieldValue("userType", newValue);
          }}
          value={values?.userType}
        />
        {/* AttemptDue */}
        <ATMSelect
          disabled={!isEditable}
          name="attemptDue"
          required
          placeholder="Attempt Due"
          label="Attempt Due"
          isLoading={isAttemptIsLoading}
          options={AttemptOptions}
          onChange={(newValue: any) => {
            setFieldValue("attemptDue", newValue);
          }}
          value={values?.attemptDue}
        />
        {/* CroNumber */}
        <ATMTextField
          disabled={!isEditable}
          required
          name="croNumber"
          value={values?.croNumber}
          onChange={(e) => {
            setFieldValue("croNumber", e.target.value);
          }}
          label="CRO Number"
          placeholder="Enter CroNumber"
          onBlur={handleBlur}
        />

        {/* DeliveryOption */}
        <ATMSelect
          disabled={!isEditable}
          name="deliveryOption"
          value={values?.deliveryOption}
          placeholder="Select Option"
          onChange={(newValue) => {
            setFieldValue("deliveryOption", newValue);
          }}
          label="DeliveryOption"
          options={DeliveryOptions}
          onBlur={handleBlur}
        />

        {values?.deliveryOption?.value === "HOME_DELIVERY" && (
          <>
            {/* Address */}
            <ATMTextField
              disabled={!isEditable}
              required
              placeholder="Enter Address"
              name="address"
              value={values?.address}
              onChange={(e) => {
                setFieldValue("address", e.target.value);
              }}
              label="Address"
              onBlur={handleBlur}
            />
            {/* City */}
            <ATMTextField
              disabled={!isEditable}
              required
              placeholder="Enter City"
              name="city"
              value={values?.city}
              onChange={(e) => {
                setFieldValue("city", e.target.value);
              }}
              label="City"
              onBlur={handleBlur}
            />
            {/* State */}
            <ATMTextField
              disabled={!isEditable}
              required
              placeholder="Enter State"
              name="state"
              value={values?.state}
              onChange={(e) => {
                setFieldValue("state", e.target.value);
              }}
              label="State"
              onBlur={handleBlur}
            />
            {/* Pincode */}
            <ATMTextField
              disabled={!isEditable}
              required
              placeholder="Enter Pincode"
              name="pincode"
              value={values?.pincode}
              onChange={(e) => {
                setFieldValue("pincode", e.target.value);
              }}
              label="Pincode"
              onBlur={handleBlur}
            />

            <ATMTextField
              disabled={!isEditable}
              name="courierCharges"
              value={values?.courierCharges}
              onChange={(e) => {
                handleValidNumber2(e) &&
                  setFieldValue("courierCharges", e.target.value);
              }}
              label="Courier charges"
              placeholder="Please enter courier charges"
            />
          </>
        )}
      </div>
      <div>
        <table className="min-w-full bg-white border rounded-md border-gray-200">
          <thead>
            <tr className="bg-gray-100">
              <th className="py-2 px-4 w-20 border-b">S No. </th>
              <th className="py-2 px-4 border-b">Product Name</th>
              <th className="py-2 px-4 border-b">Quantity</th>
            </tr>
          </thead>
          <tbody>
            {values?.products?.map((prod: any, i) => (
              <tr key={i} className="hover:bg-gray-50">

                <td className="py-2 px-4 w-20 border-b text-left">
                  {i+1 || "N/A"}
                </td>
                <td className="py-2 px-4 border-b text-center">
                  {prod?.productId?.label || "N/A"}
                </td>
                <td className="py-2 px-4 border-b text-center">
                  {prod?.quantity || "0"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Remark */}
      <div className="mt-5">
        <ATMTextArea
          disabled={!isEditable}
          name="remark"
          value={values?.remark}
          onChange={(e) => {
            setFieldValue("remark", e);
          }}
          label="Remark"
        />
      </div>
      <div className="flex justify-end">
        <ATMLoadingButton
          disabled={!isEditable}
          className="w-28"
          isLoading={isSubmitting}
          type="submit"
        >
          Update
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default OrderDetailsForm;
